import { render } from "./IQTools.vue?vue&type=template&id=7f7bb4ee&lang=pug"
import script from "./IQTools.vue?vue&type=script&lang=js"
export * from "./IQTools.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__